import { Box, type BoxProps } from "@hightouch/htui";
import type { ComponentType, ElementType, SVGAttributes } from "react";

// Sizes a UI-library icon to the nav's icon size (20px) for the `icon` prop.
export const navIcon = (Icon: ElementType) => {
  const NavIcon = (props: BoxProps) => <Box as={Icon} boxSize={5} {...props} />;
  return NavIcon;
};

// Sized once per icon, so nav items keep stable icon components across renders.
const cachedNavIcons = new Map<ElementType, ReturnType<typeof navIcon>>();
export const cachedNavIcon = (Icon: ElementType) => {
  const sized = cachedNavIcons.get(Icon) ?? navIcon(Icon);
  cachedNavIcons.set(Icon, sized);
  return sized;
};

// The nav's own icons set their 20px as props, which beat a breadcrumb's icon size, so they take the crumb's 12px the same way.
const crumbIcons = new Map<
  ElementType,
  ComponentType<SVGAttributes<SVGElement>>
>();
export const crumbIcon = (Icon: ElementType) => {
  const sized =
    crumbIcons.get(Icon) ??
    ((props: SVGAttributes<SVGElement>) => (
      <Icon {...props} width={3} height={3} />
    ));
  crumbIcons.set(Icon, sized);
  return sized;
};
